module.exports = ".form-check-input {\n    margin-left: 0;\n}\n\n.form-check-label {\n    margin-left: 20px;\n}"